import { render, staticRenderFns } from "./EditPromo.vue?vue&type=template&id=260127b4&"
import script from "./EditPromo.vue?vue&type=script&lang=js&"
export * from "./EditPromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports